export const arePackagesEqual = (packages1, packages2) => {
  if (packages2 === undefined || packages2 === null) {
    return false
  }
  if (packages1.length !== packages2.length) return false;

  return packages1.every((pkg, index) => {
    const pkg2 = packages2[index];
    return JSON.stringify(pkg) === JSON.stringify(pkg2);
  });
}

export const checkIsPkgMediaNotPresent = (packages) => {
  if (!packages || packages.length === 0 || packages === undefined || packages === null) {
    return true;
  }

  for (const pkg of packages) {
    if (!pkg.images || pkg.images.length === 0) {
      return true; 
    }

    for (const media of pkg.images) {
      if (media && media !== null && media !== undefined && media.trim() !== '') {
        return false;
      }
    }
  }

  return true;
};

export const sanitizePkgImages = (pkgData) => {
  if (!pkgData?.pkg?.pkgs || !Array.isArray(pkgData.pkg.pkgs)) {
    return pkgData;
  }

  return {
    ...pkgData,
    pkg: {
      ...pkgData.pkg,
      pkgs: pkgData.pkg.pkgs.map((pkg) => {
        const validImages = Array.isArray(pkg.images)
          ? pkg.images.filter(
              (img) =>
                typeof img === "string" &&
                img.trim() !== ""
            )
          : [];

        return {
          ...pkg,
          images: validImages.length > 0 ? validImages : []
        };
      }),
    },
  };
};

export const normalizeImages = (images = []) => {
  if (!Array.isArray(images)) return Array(4).fill(null);

  const validImages = images.filter(
    img => typeof img === "string" && img.trim() !== ""
  );

  return validImages.length > 0
    ? [...validImages.slice(0, 4), ...Array(4 - validImages.length).fill(null)]
    : Array(4).fill(null);
};

export const isPackageLocked = (sellerWeightChangeSts) =>{
        if(sellerWeightChangeSts === "T_ACTIVE" || sellerWeightChangeSts === "V_ACTIVE"){
            return true
        }
        return false;
}

